import VProgressCircular from './VProgressCircular.vue';

export { VProgressCircular };
export default VProgressCircular;
